import styled from 'styled-components'

import { fonts, mediaQueries, palette } from '../../../../styles/variables'

export const AppBannerContainer = styled.div(
  ({ maxWidth = 'auto', isCrossHidden = false }) => ({
    maxWidth,
    position: 'relative',
    padding: isCrossHidden ? '0px 15px 0px 0px' : '0px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '15px',
    minHeight: '92px',
    '@media only screen and (max-width: 1600px)': {
      width: '100%',
    },
    [mediaQueries.desktop]: {
      padding: '15px',
    },
    [mediaQueries.smallDesktop]: {
      gap: '10px',
    },
    [mediaQueries.laptop]: {
      gap: '5px',
    },
    [mediaQueries.mobile]: {
      flexDirection: 'row',
      padding: '12px 0px 24px 0px',
      gap: '0px',
    },
    [mediaQueries.smallMobile]: {
      flexDirection: 'column',
      gap: '0px',
    },
  }),
)

export const AppBannerRibbonIconWrapperStyled = styled.div(() => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  width: '92px',
  [mediaQueries.desktop]: {
    display: 'none',
  },
  [mediaQueries.smallMobile]: {
    display: 'flex',
    height: '56px',
    width: '100%',
    flexGrow: 1,
    marginBottom: '8px',
  },
}))

export const AppBannerRibbonStyled = styled.div(() => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'rotate(134.776deg) translate(-50%, 50%)',
  transformOrigin: 'left',
  width: '300px',
  height: '12px',
  background:
    'linear-gradient(90deg, #7A0D0D 0%, #D21717 57.04%, #6C0C0C 100%)',
  [mediaQueries.tablet]: {
    transform: 'rotate(90deg) translate(-50%, -50%)',
    transformOrigin: '3px 0',
  },
  [mediaQueries.smallMobile]: {
    transform: 'rotate(0deg) translate(-50%, -14px)',
    transformOrigin: '0 0',
    width: '100%',
  },
}))

export const AppBannerRibbonIconStyled = styled.div(() => ({
  lineHeight: 0,
  position: 'relative',
  transform: 'translate(5px, 5px)',
  [mediaQueries.tablet]: {
    transform: 'rotate(-45deg) translate(9px, 9px)',
  },
  [mediaQueries.smallMobile]: {
    transform: 'rotate(45deg) translate(2px, 2px)',
  },
}))

export const AppBannerWrapper = styled.div(() => ({
  display: 'flex',
  flexGrow: 1,
  [mediaQueries.tablet]: {
    gap: '15px',
    flexDirection: 'column',
  },
  [mediaQueries.mobile]: {
    padding: '0 10px',
  },
  [mediaQueries.smallMobile]: {
    gap: '4px',
  },
}))

export const AppBannerTextStyled = styled.div(() => ({
  display: 'flex',
  alignItems: 'center',
  flexGrow: 1,
  [mediaQueries.tablet]: {
    gap: '0px',
    paddingLeft: '0px',
  },
  [mediaQueries.smallMobile]: {
    flexDirection: 'column',
  },
}))

export const AppBannerTextWrapperStyled = styled.div(() => ({
  display: 'flex',
  alignItems: 'center',
}))

export const AppBannerVerticalText = styled.div(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  whiteSpace: 'nowrap',
  color: palette.white,
  textTransform: 'uppercase',
  fontFamily: fonts.primaryMedium,
  fontSize: '10px',
  lineHeight: '14.4px',
  transform: 'rotate(270deg)',
  maxWidth: '12px',
}))

export const AppBannerTextContainer = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '10px',
  marginLeft: '4px',
}))

export const AppBannerBlackFridayText = styled.div(({ theme }) => ({
  filter: 'drop-shadow(0px 3.694px 12.93px rgba(241, 100, 52, 0.30))',
  color: theme.color || palette.white,
  fontFamily: fonts.primaryBold,
  fontSize: theme.flagFontSize || '16px',
  fontWeight: 700,
  lineHeight: 'normal',
  textTransform: 'uppercase',
  whiteSpace: 'nowrap',
  height: theme.flagHeight || '24px',
  padding: theme.flagPadding || '5px 10px',
  position: 'relative',
  textAlign: 'center',
  verticalAlign: 'middle',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: theme.flagBackground || palette.orange,
    clipPath: theme?.flagClipPath || 'none',
    zIndex: -1,
  },
  [mediaQueries.smallDesktop]: {
    fontSize: '14px',
  },
}))

export const AppBannerOfferText = styled.div(({ theme }) => ({
  color: theme.color || palette.white,
  fontFamily: fonts.primaryBold,
  fontSize: '40px',
  lineHeight: '30px',
  textTransform: 'uppercase',
  whiteSpace: 'nowrap',
  height: '24px',
  display: 'block',
  position: 'relative',
  textAlign: 'center',
  verticalAlign: 'middle',
  '@media only screen and (max-width: 1600px)': {
    fontSize: '36px',
    letterSpacing: '-0.8px',
  },
  [mediaQueries.desktop]: {
    fontSize: '34px',
  },
  [mediaQueries.smallDesktop]: {
    fontSize: '32px',
  },
  [mediaQueries.laptop]: {
    fontSize: '30px',
  },
}))

export const AppBannerTextDivider = styled.hr(({ theme }) => ({
  border: `1px solid ${theme.boldColor || palette.orange}`,
  width: 0,
  height: '100%',
  margin: '0 14px',
  [mediaQueries.smallDesktop]: {
    margin: '0 10px',
  },
  [mediaQueries.laptop]: {
    margin: '0 7px',
  },
  [mediaQueries.tablet]: {
    margin: '0 14px',
    height: '60px',
  },
  [mediaQueries.smallMobile]: {
    height: 0,
    width: '60px',
    margin: '16px 0 8px',
  },
}))

export const AppBannerControls = styled.div(() => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  justifyContent: 'flex-end',
  gap: '15px',
  [mediaQueries.smallDesktop]: {
    gap: '10px',
  },
  [mediaQueries.tablet]: {
    flexDirection: 'row-reverse',
    gap: '24px',
    justifyContent: 'center',
    alignItems: 'flex-start',
    width: '100%',
  },
  [mediaQueries.smallMobile]: {
    marginTop: '10px',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '15px',
  },
  '& a': {
    width: '100%',
    [mediaQueries.tablet]: {
      display: 'flex',
      flexGrow: 1,
    },
  },
}))

export const AppBannerInfoTextProps = styled.div(({ theme }) => ({
  color: theme.color || palette.white,
  fontFamily: fonts.primaryMedium,
  fontSize: '20px',
  fontWeight: 500,
  lineHeight: '22px',
  paddingRight: '10px',
  width: '100%',
  letterSpacing: '-0.1px',
  '& b': {
    color: theme.boldColor || palette.orange,
    fontFamily: fonts.primaryMedium,
  },
  [mediaQueries.laptop]: {
    fontSize: '16px',
    flexGrow: 2,
  },
  [mediaQueries.tablet]: {
    fontSize: '24px',
    lineHeight: '26px',
    padding: 0,
    flexGrow: 2,
  },
  [mediaQueries.mobile]: {
    fontSize: '20px',
    lineHeight: '22px',
    wordBreak: 'break-word',
    minWidth: 'auto',
  },
  [mediaQueries.smallMobile]: {
    textAlign: 'center',
  },
  [mediaQueries.minMobile]: {
    fontSize: '16px',
    lineHeight: '22px',
  },
}))

export const AppBannerInfoText = styled.div(({ theme }) => ({
  color: theme.color || palette.white,
  fontFamily: fonts.primaryMedium,
  fontSize: '24px',
  fontWeight: 500,
  lineHeight: '26px',
  paddingRight: '5px',
  maxWidth: 'auto',
  letterSpacing: '-0.1px',
  '& b': {
    color: theme.boldColor || palette.orange,
    padding: '0 3px',
  },
  '@media only screen and (max-width: 1600px)': {
    minWidth: 'auto',
    fontSize: '20px',
    lineHeight: '24px',
  },
  [mediaQueries.desktop]: {
    maxWidth: '275px',
    fontSize: '16px',
  },
  [mediaQueries.laptop]: {
    paddingRight: '0px',
  },
  [mediaQueries.tablet]: {
    fontSize: '24px',
    lineHeight: '26.4px',
    maxWidth: '100%',
    letterSpacing: '-0.2px',
  },
  [mediaQueries.mobile]: {
    fontSize: '18px',
    letterSpacing: '-0.5px',
  },
  [mediaQueries.smallMobile]: {
    lineHeight: '21px',
    textAlign: 'center',
  },
}))

export const AppBannerInfoTitle = styled.div(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  '& b': {
    background: palette.white,
    padding: '0 5px',
  },
}))

export const AppBannerCounterStyled = styled.div(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  flexDirection: 'column',
}))

export const AppBannerCrossStyled = styled.div(({ theme }) => ({
  width: '32px',
  height: '32px',
  zIndex: 2,
  background: theme.background || palette.darkGray,
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginRight: '10px',
  [mediaQueries.laptop]: {
    marginRight: '5px',
  },
  [mediaQueries.tablet]: {
    position: 'absolute',
    top: '2px',
    right: '10px',
  },
  [mediaQueries.mobile]: {
    marginRight: 0,
  },
  [mediaQueries.smallMobile]: {
    top: '6.5px',
  },
}))
